import api from './api';

export interface UbicacionXUsuario {
  usuario: string;
  nroUbicacion: number;
  preferida: boolean;
  nombreUbicacion?: string | null;
}

export interface UbicacionXUsuarioSearchParams {
  searchTerm?: string;
  pageNumber: number;
  pageSize: number;
  usuario?: string;
  nroUbicacion?: number;
}

export interface UbicacionXUsuarioPagedResult {
  items: UbicacionXUsuario[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface MisUbicacionesResponse {
  items: UbicacionXUsuario[];
  preferidaNroUbicacion?: number | null;
  esAdmin: boolean;
  sinAsignaciones: boolean;
}

const ubicacionXUsuarioService = {
  getPaged: async (params: UbicacionXUsuarioSearchParams): Promise<UbicacionXUsuarioPagedResult> => {
    const response = await api.get<UbicacionXUsuarioPagedResult>('/api/UbicacionXUsuario', {
      params: {
        SearchTerm: params.searchTerm,
        PageNumber: params.pageNumber,
        PageSize: params.pageSize,
        Usuario: params.usuario,
        NroUbicacion: params.nroUbicacion,
      },
    });
    return response.data;
  },

  getByUsuario: async (usuario: string): Promise<UbicacionXUsuario[]> => {
    const response = await api.get<UbicacionXUsuario[]>(
      `/api/UbicacionXUsuario/usuario/${encodeURIComponent(usuario)}`
    );
    return response.data;
  },

  getMias: async (): Promise<MisUbicacionesResponse> => {
    const response = await api.get<MisUbicacionesResponse>('/api/UbicacionXUsuario/mias');
    return response.data;
  },

  create: async (dto: { usuario: string; nroUbicacion: number }): Promise<UbicacionXUsuario> => {
    const response = await api.post<UbicacionXUsuario>('/api/UbicacionXUsuario', dto);
    return response.data;
  },

  setPreferida: async (nroUbicacion: number, usuario: string): Promise<void> => {
    await api.put(`/api/UbicacionXUsuario/${nroUbicacion}/${encodeURIComponent(usuario)}/preferida`);
  },

  delete: async (nroUbicacion: number, usuario: string): Promise<void> => {
    await api.delete(`/api/UbicacionXUsuario/${nroUbicacion}/${encodeURIComponent(usuario)}`);
  },
};

export default ubicacionXUsuarioService;
